import { render, staticRenderFns } from "./GameLogo.vue?vue&type=template&id=077d948d&scoped=true&"
import script from "./GameLogo.vue?vue&type=script&lang=js&"
export * from "./GameLogo.vue?vue&type=script&lang=js&"
import style0 from "./GameLogo.vue?vue&type=style&index=0&id=077d948d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d948d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077d948d')) {
      api.createRecord('077d948d', component.options)
    } else {
      api.reload('077d948d', component.options)
    }
    module.hot.accept("./GameLogo.vue?vue&type=template&id=077d948d&scoped=true&", function () {
      api.rerender('077d948d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/GameLogo.vue"
export default component.exports